module.exports = __webpack_public_path__ + "img/alpha.5034e431.png";